import React from 'react'

const Course = () => {
    let courses=[
        {
            id:1,
            name:"UI & UX",
            duration:60,
            fee: 15000,
            img:"ui.webp",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        },
        {
            id:2,
            name:"JavaScript",
            duration:20,
            fee: 5000,
            img:"js.avif",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        },
        {
            id:3,
            name:"Angular",
            duration:60,
            fee: 20000,
            img:"angular.png",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        },
        {
            id:4,
            name:"React Js",
            duration:50,
            fee: 16000,
            img:"react.png",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        },
        {
            id:5,
            name:"Java",
            duration:90,
            fee: 25000,
            img:"java.webp",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Back-End"
        },
        {
            id:6,
            name:"Python",
            duration:80,
            fee: 22000,
            img:"python.jpg",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Back-End"
        },
        {
            id:7,
            name:"DotNet",
            duration:120,
            fee: 30000,
            img:"dotnet.png",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Back-End"
        },
        {
            id:8,
            name:"Node Js",
            duration:90,
            fee: 28000,
            img:"node js.webp",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Back-End"
        },
        {
            id:9,
            name:"Vue Js",
            duration:60,
            fee: 13000,
            img:"vuejs.png",
            content:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas, cupiditate",
            type:"Front-End"
        }
    ]
  return (
    <>
      <section id="courses" class="container">
                    <h1 class="text-center text-danger my-5">
                        Courses List
                    </h1>
                    <div class="row" id="item">
                        {
                            courses.map((x,index)=>{
                                return(
                                    <div class="col-md-4 col-sm-12 col-12 mb-3" key={index}>
                                        <div className="card">
                                            <img src={"assets/images/"+x.img} alt="" className="w-100" />
                                            <div className="card-body">
                                                <h2 className="card-title text-danger">{x.name.toUpperCase()}</h2>
                                                <p class="card-text">{x.content}</p>
                                                <div className="text-center">
                                                    <button className="btn btn-danger me-2">Duration: {x.duration}Hrs</button>
                                                    <button className="btn btn-success">Fee: {x.fee}/-</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </section>
    </>
  )
}

export default Course
